import React, { useState, useContext } from "react";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";
import { Stack, Box, Button } from "@mui/material";
import dayjs from "dayjs";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { GeneralContext } from '../../context/GeneralContext';
import { CuestionarioSkeleton } from "./CuestionarioSkeleton";
import { useColors } from '../../hooks/useColors'
import '../../styles/CuestionarioHistoricos.css';

export const CuestionarioHistoricos = ({ cuestionarios }) => {
  const { t } = useTranslation();
  const { getCalificationColor } = useColors()
  const navigate = useNavigate();
  const { setCuestionarioID } = useContext(GeneralContext);

  function bgColorHistorico(cuestionario) {
    if (cuestionario.diferenciaPuntuacion > 0)
      return { backgroundColor: "#DDFEDD !important" }
    else if (cuestionario.diferenciaPuntuacion < 0)
      return { backgroundColor: "#FEDADA !important" }
    else {
      return { backgroundColor: "#D4FBFE !important" }
    }
  }

  function historicoIconArrow(cuestionario) {
    if (cuestionario.diferenciaPuntuacion > 0) return <KeyboardArrowUpIcon />
    else if (cuestionario.diferenciaPuntuacion < 0)
      return <KeyboardArrowDownIcon />
    else {
      return <></>
    }
  }

  return (
    <>
      <Grid
        container
        justifyContent="center"
        alignItems="center"
        spacing={1}
        sx={{
          margin: '0 !important',
          width: 'calc(100%) !important'
        }}
      >
        {!cuestionarios ? (
          <CuestionarioSkeleton />
        ) : cuestionarios.length === 0 ? (
          <Typography paddingLeft={1} variant="overline">
             {t("misCuestionarios.nofinalizados")}
          </Typography>
        ) : (
          [...cuestionarios].reverse().map((cuestionario, index) => (
            <Grid item xs={12} sm={4} lg={4} key={index}
              minWidth="350px"
              >
              <Card style={{ height: "100%" }}>
                <CardContent>
                  <Stack
                    direction="column"
                    spacing={2}
                    className="card__content"
                  >
                    <Grid
                      container
                      justifyContent="space-between"
                      alignItems="center"
                      sx={{
                        borderBottom: "1px solid #ddd",
                        marginTop: "16px",
                        padding: ".625rem",
                      }}
                    >
                      <Grid item className="card__row__title">
                        {t("misCuestionarios.inicio")}
                      </Grid>
                      <Grid item>
                        {dayjs(cuestionario.fecha_creacion).format(
                          "DD-MM-YYYY HH:mm"
                        )}
                      </Grid>
                    </Grid>
                    <Grid
                      container
                      justifyContent="space-between"
                      alignItems="center"
                      sx={{
                        borderBottom: "1px solid #ddd",
                        padding: ".625rem",
                      }}
                    >
                      <Grid item className="card__row__title">
                        {t("misCuestionarios.fin")}
                      </Grid>
                      <Grid item>
                        {dayjs(cuestionario.fecha_fin).format(
                          "DD-MM-YYYY HH:mm"
                        )}
                      </Grid>
                    </Grid>
                    <Grid
                      container
                      justifyContent="space-between"
                      alignItems="center"
                      sx={{
                        borderBottom: "1px solid #ddd",
                        padding: ".625rem",
                      }}
                    >
                      <Grid item className="card__row__title">
                        {t("misCuestionarios.calificacion")}
                      </Grid>
                      <Grid item sx={{ color: () => getCalificationColor(cuestionario.calificacion)}}>{cuestionario.calificacion}</Grid>
                    </Grid>
                    {cuestionarios.length > 1 && (
                      <Grid
                        container
                        justifyContent="space-between"
                        alignItems="center"
                        sx={{
                          padding: ".625rem",
                          marginTop: "0 !important",
                        }}
                      >
                        <Grid item className="card__row__title">
                          {t("misCuestionarios.diferencia")}
                        </Grid>
                        <Grid item>
                          <Stack
                            direction="row"
                            justifyContent="center"
                            alignItems="center"
                            className="card__difference"
                            sx={() => bgColorHistorico(cuestionario)}
                          >
                            <Typography variant="body2" color="text.secondary">
                              {cuestionario.diferenciaPuntuacion} %
                            </Typography>
                            {historicoIconArrow(cuestionario)}
                          </Stack>
                        </Grid>
                      </Grid>
                    )}
                  </Stack>
                  <Box sx={{ textAlign: "center" }}>
                    <Button
                      variant="contained"
                      sx={{ margin: "auto" }}
                      size="large"
                      onClick={() => {
                        setCuestionarioID(cuestionario.id_cuestionario);
                        navigate("/Resultado");
                      }}
                    >
                      {t("misCuestionarios.recomendaciones")}
                    </Button>
                  </Box>
                </CardContent>
              </Card>
            </Grid>
          ))
        )}
      </Grid>
    </>
  );
};
